import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";

let idHotsiteLocalStorage = getlocalStorageIdHotsite();

export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage,
  Loja: "navegantes",
  UserStorage: "2wgfPnalok+pRK7zsADCeg==",
  UserToken: "q/+ZskbPnkWRxnjVGRjcXA==",
  UrlApi: "https://prd-ecommerce-nav-api.primecase.com.br/api",
  UrlLoja:"https://prd-ecommerce-nav-web.primecase.com.br",
  UrlServiceHost: "https://dev2-pri-sgc-api.primecase.com.br/",
  SecurityKey: "",
  OrgId: "",
  ProviderMerchantId: ""
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#810000",
      light: "#810000",
      //lighter: "#ece6f7",
      dark: darkenColor("#810000", 10), // Escurece em 20%
    },
    secondary: {
      main: "#000",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
